import { Store } from 'src/store/index';

const getProductId = (store: Store) => store.design.productId;

export default getProductId;
